import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
} from "@/components/ui";
import { useFormContext, type UseFormRegisterReturn } from "react-hook-form";
import { NumericFormat } from "react-number-format";

export interface NumericFormFieldProps {
  label?: string;
  className?: string;
  register: UseFormRegisterReturn;
  disabled?: boolean;
  placeholder?: string;
  decimalScale?: number;
  dataTestId?: string;
}

export const NumericFormField = ({
  label,
  className,
  register,
  disabled,
  placeholder,
  dataTestId,
  decimalScale,
}: NumericFormFieldProps) => {
  const form = useFormContext();
  return (
    <FormField
      control={form.control}
      {...register}
      // @ts-expect-error This line is to remove a console error
      ref={null}
      render={({ field }) => (
        <FormItem className={className}>
          <div className="flex">
            {label && <FormLabel>{label}</FormLabel>}
            <FormMessage
              data-testid="error-message"
              className="grow text-right"
            />
          </div>
          <FormControl>
            <NumericFormat
              disabled={disabled}
              data-testid={dataTestId}
              placeholder={placeholder}
              defaultValue={field.value}
              thousandSeparator=","
              customInput={Input}
              decimalScale={decimalScale ?? 0}
              {...field}
              onChange={() => {}} // This is here to prevent the field's onchange from being called - onChange in Numeric format gives the formatted string (with commas)
              onValueChange={({ value }) => {
                form.setValue(field.name, value);
                field.onChange(value);
              }}
            />
          </FormControl>
        </FormItem>
      )}
    />
  );
};
